var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterIcon = function SvgFilterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#filterIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M8.5 16a8 8 0 1 0 0-16.001A8 8 0 0 0 8.5 16M4 5h9a.5.5 0 0 1 0 1H4a.5.5 0 1 1 0-1m1.5 3.5A.5.5 0 0 1 6 8h5a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5m2 3A.5.5 0 0 1 8 11h1a.5.5 0 0 1 0 1H8a.5.5 0 0 1-.5-.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "filterIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h16v16H.5z"
  })))));
};
export default SvgFilterIcon;